<template>
  <v-app id="reset-password">
    <!-- Sfondo a tutta pagina con trasparenza forte -->
    <div class="background-image"></div>

    <!-- Form di reset password su un layer superiore -->
    <v-main>
      <v-container fluid fill-height>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="8" md="6" lg="4" xl="3">
            <v-card class="reset-card pa-8" elevation="10">
              <div class="text-center mb-8">
                <v-img src="@/assets/logo_small.png" alt="Logo" max-width="120px" contain class="mx-auto mb-4"></v-img>
                <h2 class="text-h4 font-weight-bold primary--text mb-4">
                  Recupero Password
                </h2>
                <v-divider class="mb-6"></v-divider>
                <p class="text-subtitle-2 text-secondary">
                  Inserisci la tua email per ricevere le istruzioni per reimpostare la password
                </p>
              </div>

              <v-form @submit.prevent="resetPassword" class="mb-4">
                <v-text-field
                    name="email"
                    label="Email"
                    id="email"
                    v-model="email"
                    type="email"
                    required
                    prepend-inner-icon="mdi-email"
                    outlined
                    rounded
                    dense
                    class="mb-6"
                    :error-messages="emailError"
                    @input="emailError = ''"
                    color="primary"
                ></v-text-field>

                <v-btn
                    block
                    color="primary"
                    rounded
                    elevation="4"
                    large
                    class="font-weight-bold"
                    height="48"
                    :loading="loading"
                    @click="resetPassword"
                >
                  <v-icon left class="mr-2">mdi-lock-reset</v-icon>
                  Invia istruzioni
                </v-btn>

                <div class="text-center mt-4">
                  <router-link to="/login" class="text-decoration-none">
                    <span class="primary--text">Torna al login</span>
                  </router-link>
                </div>
              </v-form>

              <div class="text-center mt-6">
                <v-divider class="mb-4"></v-divider>
                <div class="d-flex justify-center align-center">
                  <v-icon color="primary" size="18" class="mr-2">mdi-elephant</v-icon>
                  <p class="text-caption text-secondary mb-0">
                    Elefante Task Manager © {{ new Date().getFullYear() }} IF65 srl. Tutti i diritti riservati.
                  </p>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import UserService from '/src/services/user.service.js';

export default {
  name: "ResetPassword",
  data() {
    return {
      loading: false,
      email: '',
      emailError: '',
      resetSent: false
    }
  },
  methods: {
    validateForm() {
      let isValid = true;

      if (!this.email) {
        this.emailError = 'Email è obbligatoria';
        isValid = false;
      } else if (!this.validateEmail(this.email)) {
        this.emailError = 'Inserisci un indirizzo email valido';
        isValid = false;
      }

      return isValid;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    resetPassword() {
      if (!this.validateForm()) return;

      this.loading = true;

      // Chiamata al servizio per il reset della password
      UserService.resetPassword(this.email).then(
          () => {
            this.loading = false;
            this.resetSent = true;

            this.$dtoast.pop({
              preset: "success",
              content: "Istruzioni per il reset della password inviate alla tua email",
            });

            // Redirect alla pagina di login dopo un breve ritardo
            setTimeout(() => {
              this.$router.push({name: 'login'});
            }, 3000);
          }
      ).catch(
          error => {
            this.loading = false;

            let errorMessage = "Impossibile inviare le istruzioni per il reset della password. Riprova.";

            if (error.response && error.response.data) {
              if (error.response.data.detail) {
                errorMessage = error.response.data.detail;
              } else if (typeof error.response.data === 'string') {
                errorMessage = error.response.data;
              }
            }

            this.$dtoast.pop({
              preset: "error",
              content: errorMessage,
            });
          }
      )
    }
  }
}
</script>

<style scoped lang="css">
/* Stile per lo sfondo */
.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  z-index: 0;
}

/* Stile per la card di reset password */
.reset-card {
  background-color: white !important;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2) !important;
  z-index: 10;
  transition: transform 0.3s ease;
}

.reset-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3) !important;
}

/* Stile per i campi di input */
.v-text-field.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.1);
}

/* Stile per il pulsante */
.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px !important;
}
</style>
